var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-contact-relation-category-table',{attrs:{"title":_vm.$t('global.models.contact-relation-category.heading'),"subtitle":_vm.$t('global.models.contact-relation-category.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }